// TODO - Type 'any' needs to be fixed.
import { GridRowId } from "@mui/x-data-grid";
import _ from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  ASSIGN_SHIFT,
  FLEX_WORKER,
  FLEX_WORKER_TYPE_ID,
  FULL_TIME_WORKER,
  FULL_TIME_WORKER_TYPE_ID,
  LOCATION,
  PRIMARYJOB,
  SENIORITY,
  WCFIFO,
  WORKCENTER,
} from "../../../../../../assets/constants";
import { getShiftMetaData } from "../../../../../../features/worker-requests/store/worker-requests-slice";
import {
	filterShiftsByWorkerDay,
	formatFullTimeShifts,
	getConfirmedWorkersCount,
	getHourMinuteDifference,
} from "../../../../../../utils/helpers";
import {
	fetchAllWorkcenters,
	getOTWorkers,
	getShiftDetailsV2,
} from "../../../../../scheduler/store/scheduler-slice";
import useSchedulerData from "../../../../controllers/use-scheduler-data";
import {
	APPLIED,
	ASSIGNED,
	CANCELLED,
	CONFIRMED,
	DECLINED,
	NOT_ELIGIBLE,
	NOT_NOTIFIED,
	REMOVED,
	VIEWED} from "../constants";
import { NOTIFIED } from "../constants";
import { WorkersExtendedPropV2, WorkersPropsV2 } from "../types";
import useShiftDetailsDialogColumns from "./use-shift-details-dialog-columns";

const useShiftDetailsDialogController = (
	shiftId: any,
	isWorkerRequest: any,
	search: string,
	activeStep: string,
	activeTab: number,
  workerSlotSelections: { [workerId: string]: any },
  onWorkerSlotChange: (workerId: string, slot: number, customStartTime?: string, customEndTime?: string) => void,
  workersSelectedForAssignShift: GridRowId[]
) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const shiftDetailsV2 = useSelector(
		(state: any) => state.supervisor?.shiftDetailsV2?.data
	);
	const fetchAllWorkcentersStatus = useSelector(
		(state: any) => state?.supervisor?.fetchAllWorkcenters?.status
	);
	const status = useSelector(
		(state: any) => state.supervisor?.shiftDetailsV2?.status
	);

	const removeWorkerStatus = useSelector(
		(state: any) => state.supervisor?.removeWorker?.status
	); 

	const assignWorkersStatus = useSelector(
		(state: any) => state.supervisor?.assignWorkers?.status
	);

	const setOTWorkersStatus = useSelector(
		(state: any) => state.supervisor?.setOTWorkers?.status
	);

	const workers = shiftDetailsV2?.workers;
	const manualForceAssignWorkerTypeIds: number[] | undefined =
		shiftDetailsV2?.manualForceAssignWorkerTypeIds;

	// Worker types the shift's allocation rule lets a supervisor force assign.
	// Part Time is never allowed.
	const allowedForceAssignWorkerTypes = useMemo(() => {
		const typeIds = manualForceAssignWorkerTypeIds ?? [];
		const allowedTypes: string[] = [];
		if (typeIds.includes(FULL_TIME_WORKER_TYPE_ID)) {
			allowedTypes.push(FULL_TIME_WORKER);
		}
		if (typeIds.includes(FLEX_WORKER_TYPE_ID)) allowedTypes.push(FLEX_WORKER);
		return allowedTypes;
	}, [manualForceAssignWorkerTypeIds]);
	const {
		allShiftsMetadata,
		shiftDetailsMetaData,
		allJobRoles,
		allWorkCenters,
		allSkillLevels,
		filterAllLocations,
		filterAllWorkcenters,
		filterJobRoles,
		renotifyWorkersStatus,
		isWorkerSubTypeEnabled,
	} = useSchedulerData();

	const [shiftMetadata, setShiftMetadata] = useState<any>({});
	const [rowsV2, setRowsV2] = useState<WorkersExtendedPropV2[]>([]);
	const [availableWorkersForShiftRow, setAvailableWorkersForShiftRow] =
		useState<WorkersExtendedPropV2[] | undefined>(undefined);
	const [jobRoleMetadata, setJobRoleMetadata] = useState({});
	const [workCenterMetadata, setWorkCenterMetadata] = useState({});
	const [confirmedWorkersCount, setConfirmedWorkersCount] = useState<number>(0);
	const [remainingFilledPartialSlots, setRemainingFilledPartialSlots] = useState<number>(0);
	const [appliedWorkersCount, setAppliedWorkersCount] = useState<number>(0);
	const [statusOptions, setStatusOptions] = useState<any[]>([]);
	const [iAmSure, setIAmSure] = useState(false);
	const [removeWorkerDialogOpen, setRemoveWorkerDialogOpen] =
		useState<any>(false); //TODO
	const [removeWorkerDetail, setRemoveWorkerDetail] = useState<any>(undefined);	
	const [
		availablePreferredWorkersForShiftRow,
		setAvailablePreferredWorkersForShiftRow,
	] = useState<WorkersExtendedPropV2[] | undefined>(undefined);
  const [totalFullSpotsConfirmed, setTotalFullSpotsConfirmed] = useState<number>(0);
  const [totalFlexiSpotsConfirmed, setTotalFlexiSpotsConfirmed] = useState<number>(0);
  const [totalFlexiSpotsTotal, setTotalFlexiSpotsTotal] = useState<number>(0);
  const [totalHalfSpotsConfirmed, setTotalHalfSpotsConfirmed] = useState<number>(0);
  const [openFlexiSlots, setOpenFlexiSlots] = useState<{start: string, end: string, isFullSpot?: boolean, prevWorkerId?: string, nextWorkerId?: string}[]>([]);

  const [totalFirstHalfSpotsConfirmed, setTotalFirstHalfSpotsConfirmed] = useState<number>(0);
  const [totalSecondHalfSpotsConfirmed, setTotalSecondHalfSpotsConfirmed] = useState<number>(0);

  const [lastUsedActiveStep, setLastUsedActiveStep] = useState<string>("");
  const [lastUsedSelections, setLastUsedSelections] = useState<{ [workerId: string]: any }>({});
  const [lastUsedWorkersSelectedForAssignShift, setLastUsedWorkersSelectedForAssignShift] = useState<GridRowId[]>([]);
  const [lastUsedOpenFlexiSlots, setLastUsedOpenFlexiSlots] = useState<any[]>([]);
  const [lastUsedAvailableSlots, setLastUsedAvailableSlots] = useState<any>({});
  const [lastUsedShiftMetadata, setLastUsedShiftMetadata] = useState<any>({});

  useEffect(() => {
		// fetch the data
		if (shiftId) {
			dispatch(getShiftDetailsV2({ shiftid: shiftId }));
		}
	}, [dispatch, shiftId]);

	// Refresh workers after renotify
	useEffect(() => {
		if (renotifyWorkersStatus === "fulfilled" || removeWorkerStatus === "fulfilled" ) {
			dispatch(getShiftDetailsV2({ shiftid: shiftId }));
		}
	}, [dispatch, renotifyWorkersStatus, shiftId, removeWorkerStatus]);

	// A rejected assignment can mean the allocation rule's worker types changed
	// after the dialog opened, so reload the current settings and workers
	useEffect(() => {
		if (
			shiftId &&
			(assignWorkersStatus === "error" || setOTWorkersStatus === "error")
		) {
			dispatch(getShiftDetailsV2({ shiftid: shiftId }));
		}
	}, [dispatch, shiftId, assignWorkersStatus, setOTWorkersStatus]);

	useEffect(() => {
		if (
			(shiftMetadata?.shiftAllocationType === WORKCENTER ||
        shiftMetadata?.shiftAllocationType === WCFIFO ||
				shiftMetadata?.shiftAllocationType === LOCATION ||
				shiftMetadata?.shiftAllocationType === PRIMARYJOB ||
				shiftMetadata?.shiftAllocationType === SENIORITY) &&
			!shiftMetadata?.enableManualAssignment &&
			allowedForceAssignWorkerTypes.length > 0 &&
			getHourMinuteDifference(new Date(shiftMetadata?.startDate || shiftMetadata?.startDateTime), new Date())
				.differenceInMinutes 
		) {
			dispatch(getOTWorkers({ shiftId: shiftMetadata?.id }));
		}
	}, [dispatch, shiftMetadata, allowedForceAssignWorkerTypes]);

	// Set master data for jobs and worcenters
	useEffect(() => {
		if (
			(allJobRoles.length === 0 || allWorkCenters.length === 0) &&
			isWorkerRequest &&
			fetchAllWorkcentersStatus === "idle"
		) {
			// No need to call job roles since we already call it while loading initial worker requests
			dispatch(fetchAllWorkcenters());
		}
	}, [
		dispatch,
		allJobRoles,
		allWorkCenters,
		isWorkerRequest,
		fetchAllWorkcentersStatus,
	]);

	useEffect(() => {
		const confirmedCount = rowsV2.filter(
			(row) => row.status === CONFIRMED
		).length;
		const assignedCount = rowsV2.filter(
			(row) => row.status === ASSIGNED
		).length;
		const declinedCount = rowsV2.filter(
			(row) => row.status === DECLINED
		).length;
		const appliedCount = rowsV2.filter((row) => row.status === APPLIED).length;
		const notifiedCount = rowsV2.filter(
			(row) => row.status === NOTIFIED
		).length;
		const viewedCount = rowsV2.filter((row) => row.status === VIEWED).length;
		const notNotifiedCount = rowsV2.filter(
			(row) => row.status === NOT_NOTIFIED
		).length;
		const notEligibleCount = rowsV2.filter(
			(row) => row.status === NOT_ELIGIBLE
		).length;
		const cancelledCount = rowsV2.filter(
			(row) => row.status === CANCELLED
		).length;

		const removedCount = rowsV2.filter(
			(row) => row.status === REMOVED
		).length;
		setStatusOptions([
			{
				label: CONFIRMED,
				checked: false,
				icon: CONFIRMED,
				count: confirmedCount,
			},
			{
				label: ASSIGNED,
				checked: false,
				icon: ASSIGNED,
				count: assignedCount,
			},
			{
				label: APPLIED,
				checked: false,
				icon: APPLIED,
				count: appliedCount,
			},
			{
				label: DECLINED,
				checked: false,
				icon: DECLINED,
				count: declinedCount,
			},
			{
				label: CANCELLED,
				checked: false,
				icon: CANCELLED,
				count: cancelledCount,
			},
			{
				label: VIEWED,
				checked: false,
				icon: VIEWED,
				count: viewedCount,
			},
			{
				label: NOT_ELIGIBLE,
				checked: false,
				icon: NOT_ELIGIBLE,
				count: notEligibleCount,
			},
			{
				label: NOTIFIED,
				checked: false,
				icon: NOTIFIED,
				count: notifiedCount,
			},
			{
				label: NOT_NOTIFIED,
				checked: false,
				icon: NOT_NOTIFIED,
				count: notNotifiedCount,
			},
			{
				label: REMOVED,
				checked: false,
				icon: REMOVED,
				count: removedCount,
			},
		]);
	}, [rowsV2]);

	// for full time worker requests page
	useEffect(() => {
		if (isWorkerRequest) {
			dispatch(getShiftMetaData(shiftId));
		}
	}, [dispatch, shiftId, isWorkerRequest]);

	// Set shift meta data when dialog is opened in flex scheduler
	useEffect(() => {
		if (allShiftsMetadata && !isWorkerRequest && status === "fulfilled") {
			const currentShiftData = allShiftsMetadata.find(
				(shift: any) => shift.id === shiftId
			);
			if (currentShiftData) {
				const workCenterData = filterAllWorkcenters.find(
					(workCenter: any) => workCenter.id === currentShiftData.workCenterId
				);
				const locationData = filterAllLocations.find(
					(location: any) => location.id === workCenterData.locationId
				);
				const jobRoleData = filterJobRoles.find(
					(jobRole: any) => jobRole.id === currentShiftData.jobId
				);
				if (workCenterData && locationData) {
					setShiftMetadata((prev: any) => {
						const newMetadata = {
							...currentShiftData,
							shiftWorkcenterName: workCenterData.name,
							shiftLocationName: locationData.name,
							shiftLocationClusterName: shiftDetailsV2.locationCluster ?? null,
							shiftJobRole: jobRoleData ?? "",
							autoForceAssignment: shiftDetailsV2.autoForceAssignment ?? false,
							allowedWorkerTypeIds: shiftDetailsV2?.allowedWorkerTypeIds ?? currentShiftData?.allowedWorkerTypeIds ?? null,
						};
						if (JSON.stringify(prev) === JSON.stringify(newMetadata)) {
							return prev; // Prevent redundant state update
						}
						return newMetadata;
					});
				}
			}
		}
	}, [
		allShiftsMetadata,
		shiftId,
		isWorkerRequest,
		filterAllWorkcenters,
		filterAllLocations,
		filterJobRoles,
		shiftDetailsV2,
		status,
	]);

	// Set shift meta data when dialog is opened in full time worker requests page
	useEffect(() => {
		if (isWorkerRequest && shiftDetailsMetaData) {
			// set workcenter name location name and job role
			const currentWorkCenter = allWorkCenters.find(
				(workCenter: any) => workCenter.id === shiftDetailsMetaData.workCenterId
			);
			const jobRoleData = allJobRoles.find(
				(jobRole: any) => jobRole.id === shiftDetailsMetaData.jobId
			);
			const shiftLocationName = currentWorkCenter?.location?.name;
			const shiftWorkcenterName = currentWorkCenter?.name;
			setShiftMetadata((prev: any) => {
				const newMetadata = {
					...shiftDetailsMetaData,
					shiftLocationName,
					shiftWorkcenterName,
					shiftJobRole: jobRoleData,
					allowedWorkerTypeIds: shiftDetailsV2?.allowedWorkerTypeIds ?? null,
				};
				if (JSON.stringify(prev) === JSON.stringify(newMetadata)) {
					return prev; // Prevent redundant state update
				}
				return newMetadata;
			});
		}
	}, [isWorkerRequest, shiftDetailsMetaData, allWorkCenters, allJobRoles, shiftDetailsV2]);

	useEffect(() => {
		if (allJobRoles) {
			const currentJobRole = allJobRoles.find(
				(jobRole: any) => jobRole.id === shiftMetadata?.jobId
			);
			if (currentJobRole) {
				setJobRoleMetadata(currentJobRole);
			}
		}
	}, [allJobRoles, shiftMetadata?.jobId]);

	useEffect(() => {
		if (allWorkCenters) {
			const currentWorkCenter = allWorkCenters.find(
				(workCenter: any) => workCenter.id === shiftMetadata?.workCenterId
			);
			if (currentWorkCenter) {
				setWorkCenterMetadata(currentWorkCenter);
			}
		}
	}, [allWorkCenters, shiftMetadata?.workCenterId]);

	useEffect(() => {
		try {
			if (Array.isArray(rowsV2)) {
				// Update confirmed workers count based on worker row data
				const totalConfirmedWorkers = rowsV2.filter(
					(worker) => worker.status === CONFIRMED
				);
				const totalAssignedWorkers = rowsV2.filter(
					(worker) => worker.status === ASSIGNED
				);

				const occupiedWorkers = [...totalConfirmedWorkers, ...totalAssignedWorkers];

				const uiModifiedWorkerIds = Array.from(new Set([
					...workersSelectedForAssignShift.map(id => String(id)),
					...Object.keys(workerSlotSelections)
				]));

				if (uiModifiedWorkerIds.length > 0) {
					uiModifiedWorkerIds.forEach((workerId) => {
						const worker = rowsV2.find((r) => String(r.workerId) === String(workerId));
						if (worker) {
							const selection = workerSlotSelections[workerId] ?? workerSlotSelections[String(workerId)];
							let workerShiftStartDateTime = shiftMetadata.startDateTime;
							let workerShiftEndDateTime = shiftMetadata.endDateTime;

							if (typeof selection === "object") {
								workerShiftStartDateTime = selection.customStartTime;
								workerShiftEndDateTime = selection.customEndTime;
							} else if (selection === 1) {
								const duration = getHourMinuteDifference(
									new Date(shiftMetadata.endDateTime),
									new Date(shiftMetadata.startDateTime)
								).differenceInMinutes;
								workerShiftEndDateTime = new Date(
									new Date(shiftMetadata.startDateTime).getTime() +
										(duration / 2) * 60 * 1000
								).toISOString();
							} else if (selection === 2) {
								const duration = getHourMinuteDifference(
									new Date(shiftMetadata.endDateTime),
									new Date(shiftMetadata.startDateTime)
								).differenceInMinutes;
								workerShiftStartDateTime = new Date(
									new Date(shiftMetadata.startDateTime).getTime() +
										(duration / 2) * 60 * 1000
								).toISOString();
							}

							const existingIndex = occupiedWorkers.findIndex((w) => String(w.workerId) === String(workerId));
							if (existingIndex === -1) {
								occupiedWorkers.push({
									...worker,
									workerShiftStartDateTime,
									workerShiftEndDateTime,
								});
							} else {
								occupiedWorkers[existingIndex] = {
									...occupiedWorkers[existingIndex],
									workerShiftStartDateTime,
									workerShiftEndDateTime,
								};
							}
						}
					});
				}

				if (
					totalConfirmedWorkers !== undefined &&
					totalConfirmedWorkers !== null
				) {
					const overlappingSignupLimit = shiftDetailsV2?.overlappingSignupLimitMins ?? 0;
					const shiftStartTime = shiftMetadata?.startDateTime;
					const shiftEndTime = shiftMetadata?.endDateTime;
					const filteredNonOvertimeWorkersWhoCoveredFullShift =
						totalConfirmedWorkers.filter((worker) => {
							const workerShiftStartDateTime = worker.workerShiftStartDateTime ?? shiftStartTime;
							const workerShiftEndDateTime = worker.workerShiftEndDateTime ?? shiftEndTime;
							if (workerShiftStartDateTime && workerShiftEndDateTime) {
								const startTimeDiff = getHourMinuteDifference(
									new Date(workerShiftStartDateTime),
									new Date(shiftStartTime)
								);
								const endTimeDiff = getHourMinuteDifference(
									new Date(shiftEndTime),
									new Date(workerShiftEndDateTime)
								);
								return (
									startTimeDiff.differenceInMinutes === 0 &&
									endTimeDiff.differenceInMinutes === 0
								);
							}
							return false;
						});
					const filteredNonOvertimeWorkersCount = filteredNonOvertimeWorkersWhoCoveredFullShift.length;
					const fullTimeWorkers = totalConfirmedWorkers.filter(
						(worker) => worker.workerType === FULL_TIME_WORKER
					);
					const overlappingWorkers = fullTimeWorkers.filter((worker) => {
						const workerShiftStartDateTime = worker.workerShiftStartDateTime ?? shiftStartTime;
						const workerShiftEndDateTime = worker.workerShiftEndDateTime ?? shiftEndTime;
						if (workerShiftStartDateTime && workerShiftEndDateTime) {
							const startTimeDiff = getHourMinuteDifference(
								new Date(workerShiftStartDateTime),
								new Date(shiftStartTime)
							);
							const endTimeDiff = getHourMinuteDifference(
								new Date(shiftEndTime),
								new Date(workerShiftEndDateTime)
							);
							return (
								((startTimeDiff.differenceInMinutes > 0  &&
										startTimeDiff.differenceInMinutes <= overlappingSignupLimit) ||
									(endTimeDiff.differenceInMinutes > 0 &&
										endTimeDiff.differenceInMinutes <= overlappingSignupLimit)) &&
								(worker?.workerShiftSlot === 0
									|| worker?.workerShiftSlot === null)
							);
						}
						return false;
					});
					const overlappingWorkersCount = overlappingWorkers.length;

					const partiallySignedUpWorkers = [...totalConfirmedWorkers,...totalAssignedWorkers].filter((worker) => {
						const workerShiftStartDateTime = worker.workerShiftStartDateTime ?? shiftStartTime;
						const workerShiftEndDateTime = worker.workerShiftEndDateTime ?? shiftEndTime;
						if (workerShiftStartDateTime && workerShiftEndDateTime) {
							const startTimeDiff = getHourMinuteDifference(
								new Date(workerShiftStartDateTime),
								new Date(shiftStartTime)
							);
							const endTimeDiff = getHourMinuteDifference(
								new Date(shiftEndTime),
								new Date(workerShiftEndDateTime)
							);
							return (
								((startTimeDiff.differenceInMinutes > 0 &&
								endTimeDiff.differenceInMinutes === 0) ||
								(startTimeDiff.differenceInMinutes === 0 &&
								endTimeDiff.differenceInMinutes > 0)) &&
								(overlappingWorkers.findIndex(overlappingWorker =>
									String(overlappingWorker.workerId) === String(worker.workerId)) === -1)
							);
						}
						return false;
					});
          const totalShiftDuration = getHourMinuteDifference(
            new Date(shiftEndTime),
            new Date(shiftStartTime)
          );

					// Count of spots filled by combinations of workers covering first and second half
					const workersCountForFirstHalf = partiallySignedUpWorkers.filter((worker) => {
						const workerShiftStartDateTime = worker.workerShiftStartDateTime ?? shiftStartTime;
            const workerShiftEndDateTime = worker.workerShiftEndDateTime ?? shiftEndTime;
						if (workerShiftStartDateTime) {
              const endTimeDiff = getHourMinuteDifference(
                new Date(shiftEndTime),
                new Date(workerShiftEndDateTime)
              );
							return endTimeDiff.differenceInMinutes === totalShiftDuration.differenceInMinutes/2;
						}
						return false;
					}).length;
					const workersCountForSecondHalf = partiallySignedUpWorkers.filter((worker) => {
            const workerShiftStartDateTime = worker.workerShiftStartDateTime ?? shiftStartTime;
						const workerShiftEndDateTime = worker.workerShiftEndDateTime ?? shiftEndTime;
						if (workerShiftEndDateTime && workerShiftStartDateTime) {
              const startTimeDiff = getHourMinuteDifference(
                new Date(workerShiftStartDateTime),
                new Date(shiftStartTime)
              );
							return startTimeDiff.differenceInMinutes === totalShiftDuration.differenceInMinutes/2;
						}
						return false;
					}).length;

					const modifierForSlotFilled = 2 * Math.min(
						workersCountForFirstHalf,
						workersCountForSecondHalf
					) ?? 0;

					const spotFilledByCombinations = Math.floor(
						modifierForSlotFilled/2
					) ?? 0;

          const leftOutPartialSlots = Math.abs(workersCountForFirstHalf - workersCountForSecondHalf);

          const fullSpotCount =  overlappingWorkersCount
            + filteredNonOvertimeWorkersCount
            + totalAssignedWorkers.length
            - workersCountForFirstHalf
            - workersCountForSecondHalf;

          const confirmedWorkersCount = overlappingWorkersCount
            + filteredNonOvertimeWorkersCount
            + totalAssignedWorkers.length
            + spotFilledByCombinations
            - workersCountForFirstHalf
            - workersCountForSecondHalf;

					setRemainingFilledPartialSlots(leftOutPartialSlots);

          const fullSlotsFromMetadata = shiftMetadata?.fullSlots ?? fullSpotCount;
          const firstHalfSlotsFromMetadata = shiftMetadata?.firstHalfSlots ?? workersCountForFirstHalf;
          const secondHalfSlotsFromMetadata = shiftMetadata?.secondHalfSlots ?? workersCountForSecondHalf;

          if (shiftMetadata?.isFlexiSignupEnabled) {
            const minHours = shiftMetadata?.minFlexiSignupHours || 0;
            const shiftStart = new Date(shiftMetadata.startDateTime).getTime();
            const shiftEnd = new Date(shiftMetadata.endDateTime).getTime();
            const minMs = minHours * 60 * 60 * 1000;
            const needed = parseInt(shiftMetadata?.numberOfWorkersNeeded) || 0;

            const getPackingResults = (workersList: any[]) => {
              const sortedWorkers = [...workersList].sort((a, b) =>
                new Date(a.workerShiftStartDateTime || shiftMetadata.startDateTime).getTime() -
                new Date(b.workerShiftStartDateTime || shiftMetadata.startDateTime).getTime()
              );

              const rows: any[][] = [];
              sortedWorkers.forEach(worker => {
                const wStart = new Date(worker.workerShiftStartDateTime || shiftMetadata.startDateTime).getTime();
                let placed = false;
                for (const row of rows) {
                  const lastWorker = row[row.length - 1];
                  const lastWEnd = new Date(lastWorker.workerShiftEndDateTime || shiftMetadata.endDateTime).getTime();
                  if (wStart >= lastWEnd) {
                    row.push(worker);
                    placed = true;
                    break;
                  }
                }
                if (!placed) {
                  rows.push([worker]);
                }
              });

              while (rows.length < needed) {
                rows.push([]);
              }

              let openSpots = 0;
              let flexiFullOpenSpotsCount = 0;
              const openSlots: {
                start: string;
                end: string;
                isFullSpot?: boolean;
                prevWorkerId?: string;
                nextWorkerId?: string;
              }[] = [];
              rows.forEach(row => {
                if (row.length === 0) {
                  const shiftStart = new Date(shiftMetadata.startDateTime).getTime();
                  const shiftEnd = new Date(shiftMetadata.endDateTime).getTime();
                  if (shiftEnd - shiftStart >= minMs) {
                    openSpots += 1;
                    flexiFullOpenSpotsCount += 1;
                    openSlots.push({
                      start: shiftMetadata.startDateTime,
                      end: shiftMetadata.endDateTime,
                      isFullSpot: true
                    });
                  }
                  return;
                }

                let currentTime = shiftStart;
                // Track the worker on each side of a gap so a leftover spot can
                // be attributed to the worker(s) whose window created it.
                let prevWorker: any = null;
                row.forEach(worker => {
                  const wStart = new Date(worker.workerShiftStartDateTime || shiftMetadata.startDateTime).getTime();
                  const wEnd = new Date(worker.workerShiftEndDateTime || shiftMetadata.endDateTime).getTime();

                  // Only surface a leftover gap as an assignable open spot when
                  // it can hold at least the minimum flexi hours. Sub-min
                  // leftovers (e.g. from a custom-hours assignment) must not
                  // count, otherwise the Assign button keeps showing and a new
                  // worker could be assigned to a window shorter than allowed.
                  if (wStart - currentTime > 0 && wStart - currentTime >= minMs) {
                    openSpots += 1;
                    const isFull = currentTime === shiftStart && wStart === shiftEnd;
                    openSlots.push({
                      start: new Date(currentTime).toISOString(),
                      end: new Date(wStart).toISOString(),
                      isFullSpot: isFull,
                      prevWorkerId: prevWorker?.workerId || prevWorker?.id,
                      nextWorkerId: worker.workerId || worker.id,
                    });
                  }
                  currentTime = wEnd;
                  prevWorker = worker;
                });

                if (shiftEnd - currentTime > 0 && shiftEnd - currentTime >= minMs) {
                  openSpots += 1;
                  const isFull = currentTime === shiftStart;
                  openSlots.push({
                    start: new Date(currentTime).toISOString(),
                    end: new Date(shiftEnd).toISOString(),
                    isFullSpot: isFull && row.length === 0, // row.length === 0 case is already handled above, but just for safety
                    prevWorkerId: prevWorker?.workerId || prevWorker?.id,
                  });
                }
              });
              return { openSpots, flexiFullOpenSpotsCount, openSlots };
            };

            const initialPackingResults = getPackingResults([...totalConfirmedWorkers, ...totalAssignedWorkers]);
            const currentPackingResults = getPackingResults(occupiedWorkers);

            const shiftDurationHours = (shiftEnd - shiftStart) / (1000 * 60 * 60);
            const spotsPerWorker = minHours > 0 ? Math.floor(shiftDurationHours / minHours) : 1;
            const totalFlexiSpotsCalculated = needed * spotsPerWorker;

            setTotalFlexiSpotsConfirmed(occupiedWorkers.length);
            setTotalFlexiSpotsTotal(totalFlexiSpotsCalculated);
            setOpenFlexiSlots(currentPackingResults.openSlots);

            setTotalFullSpotsConfirmed(needed - initialPackingResults.flexiFullOpenSpotsCount);
            setTotalFirstHalfSpotsConfirmed(0);
            setTotalSecondHalfSpotsConfirmed(0);
          } else {
            setTotalFullSpotsConfirmed(
              fullSlotsFromMetadata > 0 ? fullSlotsFromMetadata : 0
            );
            setTotalFirstHalfSpotsConfirmed(firstHalfSlotsFromMetadata);
            setTotalSecondHalfSpotsConfirmed(secondHalfSlotsFromMetadata);
          }

          setTotalHalfSpotsConfirmed(
            (shiftMetadata?.isFlexiSignupEnabled ? 0 : firstHalfSlotsFromMetadata)
            + (shiftMetadata?.isFlexiSignupEnabled ? 0 : secondHalfSlotsFromMetadata)
          );
          setConfirmedWorkersCount(
            getConfirmedWorkersCount(shiftMetadata) || (confirmedWorkersCount > 0 ? confirmedWorkersCount : 0)
          );
        }
				// Update applied workers count based on worker row data
				const totalAppliedWorkers = rowsV2.filter(
					(worker) => worker.status === APPLIED
				);
				if (totalAppliedWorkers !== undefined && totalAppliedWorkers !== null) {
					setAppliedWorkersCount(totalAppliedWorkers.length);
				}
			}
		} catch (e) {
			// Do nothing
		}
	}, [rowsV2, shiftDetailsV2, shiftMetadata, activeStep, workersSelectedForAssignShift, workerSlotSelections]);

	useEffect(() => {
		const rowsV2: WorkersExtendedPropV2[] = [];
		if (workers) {
			const order: Map<string, number> = new Map([
				[CONFIRMED, 1],
				[ASSIGNED, 2],
				[APPLIED, 3],
				[DECLINED, 4],
				[CANCELLED, 5],
				[VIEWED, 6],
				[NOT_ELIGIBLE, 7],
				[NOTIFIED, 8],
				[NOT_NOTIFIED, 9],
			]);
			workers.forEach((obj: WorkersPropsV2, index: number) => {
				let newStatus = obj.status;
				if (
					obj.status === "Accepted" &&
					Object.prototype.hasOwnProperty.call(obj, "isAssigned")
				) {
					if (obj.isAssigned === true) {
						newStatus = ASSIGNED;
					} else {
						newStatus = CONFIRMED;
					}
				}
				if (obj.status === "Interested") {
					newStatus = APPLIED;
					// if(new Date() > new Date(shiftMetadata?.windowClosingTime)) {
					//   newStatus = NOT_ELIGIBLE;
					// }
					// else{
					//   newStatus = APPLIED;
					// }
				}
				const newObj = {
					...obj,
					reason:
						newStatus === ASSIGNED
							? ""
							: obj.reason
							? obj.reason
							: obj.cancelReason
							? obj.cancelReason
							: "",
					status: newStatus,
					id: obj.workerId,
					overtime: obj.workerFlexTime ? obj.workerFlexTime : t("common_not-applicable"),
					overtimeMins: obj.workerFlexMinutes ? obj.workerFlexMinutes : 0,
					errorMessage: "",
					order: order.get(newStatus) ?? 0,
          acceptanceOrder: index,
					fullTimeShifts: formatFullTimeShifts(
						filterShiftsByWorkerDay(
							obj.ftShifts,
							obj.workerTimeZone,
							shiftMetadata
						),
						obj.shiftPatternName
					), // All shifts in a day of this worker
				};
				rowsV2.push(newObj);
			});
		}
		const sortedRows: WorkersExtendedPropV2[] = _.orderBy(rowsV2, "order", [
			"asc",
		]);
		setRowsV2(sortedRows);
		// Pre-window picker offers only the worker types the rule allows
		setAvailablePreferredWorkersForShiftRow(
			sortedRows.filter((row) =>
				allowedForceAssignWorkerTypes.includes(row.workerType)
			)
		);

		try {
			const sortedRows: WorkersExtendedPropV2[] = _.orderBy(rowsV2, "order", [
				"asc",
			]);
			setRowsV2(sortedRows);
			// Allow only notified viewed none declined or applied workers
			const allowedStatusForForceAssignShift = [
				NOTIFIED,
				VIEWED,
				NOT_NOTIFIED,
				DECLINED,
				CANCELLED,
				APPLIED,
			];
			let availableWorkers: WorkersExtendedPropV2[] = sortedRows.filter(
				(row: WorkersExtendedPropV2) =>
					allowedStatusForForceAssignShift.includes(row.status)
			);

			// Allow only the worker types the shift's allocation rule allows
			availableWorkers = availableWorkers.filter((worker) =>
				allowedForceAssignWorkerTypes.includes(worker.workerType)
			);

			availableWorkers = availableWorkers.map((worker, index) => {
				return {
					...worker,
					errorMessage: "",
					panelId: index, // Require number only for detailed panel in mui datagrid
				};
			});
			availableWorkers = _.orderBy(availableWorkers, "order", ["asc"]);
			if (availableWorkers.length === 0) {
				setAvailableWorkersForShiftRow(undefined);
			} else {
				setAvailableWorkersForShiftRow(availableWorkers);
			}
		} catch (e) {
			console.log("Error setting worker row view details:", e);
		}
	}, [workers, shiftMetadata, t, allowedForceAssignWorkerTypes]);

	// : TODO: 
	
	const handleRemoveWorker = useCallback((worker : any) => {
		setRemoveWorkerDetail(worker)
		setRemoveWorkerDialogOpen(true)
	}, []);

	const closeRemoveWorkerDialog = useCallback(() => {
		setRemoveWorkerDetail(undefined)
		setRemoveWorkerDialogOpen(false)
	}, []);

  const workersRequired = useMemo(() => {
    return parseInt(shiftMetadata.numberOfWorkersNeeded);
  }, [shiftMetadata]);

  const availableSlots = useMemo(() => {
    // STEP 1: Calculate the initial number of each slot type available,
    // before accounting for the new selections being made in the UI.
    const combinedFullSlotConfirmed = Math.floor(
      (totalFirstHalfSpotsConfirmed + totalSecondHalfSpotsConfirmed) / 2
    );
    const initialFirstHalfSlots =
      workersRequired - totalFullSpotsConfirmed - totalFirstHalfSpotsConfirmed;
    const initialSecondHalfSlots =
      workersRequired - totalFullSpotsConfirmed - totalSecondHalfSpotsConfirmed;

    // STEP 2: Count the new slot selections being made in the UI.
    const selections = Object.values(workerSlotSelections);
    const uiFullSelections = selections.filter(s => s === 0).length;
    const uiFirstHalfSelections = selections.filter(s => s === 1).length;
    const uiSecondHalfSelections = selections.filter(s => s === 2).length;

    // STEP 3: Calculate the final remaining half-shift slots.
    // A first half is taken by either a full-shift selection or a first-half selection.
    const availableFirstHalf = initialFirstHalfSlots - uiFullSelections - uiFirstHalfSelections;
    const availableSecondHalf = initialSecondHalfSlots - uiFullSelections - uiSecondHalfSelections;

    // STEP 4: The number of available full shifts is the minimum of the available halves.
    // You can't offer a full shift if either half is already taken.
    const availableFull = Math.min(availableFirstHalf, availableSecondHalf);

    // Return the final counts, ensuring they don't go below zero.
    return {
      fullShift: Math.max(0, availableFull),
      firstHalf: Math.max(0, availableFirstHalf),
      secondHalf: Math.max(0, availableSecondHalf),
    };

  }, [
    workersRequired,
    totalFullSpotsConfirmed,
    totalFirstHalfSpotsConfirmed,
    totalSecondHalfSpotsConfirmed,
    workerSlotSelections
  ]);

  const generatedColumns = useShiftDetailsDialogColumns(
		shiftMetadata,
		activeTab === 0 ? rowsV2?.filter(
			worker => worker.status === CONFIRMED
				|| worker.status === ASSIGNED
		)?.length ?? 0 : rowsV2?.length ?? 0,
		availableWorkersForShiftRow ? availableWorkersForShiftRow.length : 0,
		search,
		activeStep,
		shiftDetailsV2 ? shiftDetailsV2.shiftAllocationType : "",
		shiftDetailsV2 ? shiftDetailsV2.isShiftOpenForOtherLocation : false,
		isWorkerSubTypeEnabled,
		shiftDetailsV2 ? shiftDetailsV2.isOverlappigSignupEnabled : false,
		shiftDetailsV2 ? shiftDetailsV2.isPartialSignupEnabled : false,
		shiftDetailsV2 ? shiftDetailsV2.isFlexiSignupEnabled : false,
		shiftDetailsV2 ? shiftDetailsV2.overlappingSignupLimitMins : 0,
		shiftDetailsV2 ? shiftDetailsV2.workers : [],
		handleRemoveWorker,	// TODO
    totalFirstHalfSpotsConfirmed,
    totalSecondHalfSpotsConfirmed,
    totalFullSpotsConfirmed,
    workersRequired,
    workerSlotSelections,
    onWorkerSlotChange,
    availableSlots,
    workersSelectedForAssignShift,
    openFlexiSlots,
    activeTab
  );

  const { allColumns } = useMemo(() => {
    const startDateTime = shiftMetadata ? new Date(shiftMetadata?.startDateTime) : null;
    const endDateTime = shiftMetadata ? new Date(shiftMetadata?.endDateTime) : null;

    if (
      (startDateTime && isNaN(startDateTime.getTime())) ||
      (endDateTime && isNaN(endDateTime.getTime()))
    ) {
      return {allColumns: []};
    }
    return generatedColumns;
  }, [generatedColumns, shiftMetadata]);

  const [columnOptions, setColumnOptions] = useState<any[]>([]);
  useEffect(() => {
    // If the master list of columns isn't ready yet, do nothing.
    if (allColumns.length === 0) {
      return;
    }

    // Create a map of the user's current checked states for existing columns.
    const currentCheckedState = new Map(
      columnOptions.map(col => [col.field, col.checked])
    );

    // Reconcile the new master list with the user's selections.
    const newColumnOptions = allColumns.map(masterCol => ({
      ...masterCol,
      // If we have a saved state for this column from the user, use it.
      // Otherwise (if it's a new column), use its default `checked` value.
      checked: currentCheckedState.has(masterCol.field)
        ? currentCheckedState.get(masterCol.field)
        : masterCol.checked,
    }));

    // Only update state if the columns have actually changed to prevent render loops.
    // (This is a simple but effective way to check for changes in the array of objects).
    if (JSON.stringify(newColumnOptions) !== JSON.stringify(columnOptions)
      || activeStep !== lastUsedActiveStep
      || JSON.stringify(workerSlotSelections) !== JSON.stringify(lastUsedSelections)
      || JSON.stringify(workersSelectedForAssignShift) !== JSON.stringify(lastUsedWorkersSelectedForAssignShift)
      || JSON.stringify(openFlexiSlots) !== JSON.stringify(lastUsedOpenFlexiSlots)
      || JSON.stringify(availableSlots) !== JSON.stringify(lastUsedAvailableSlots)
      || JSON.stringify(shiftMetadata) !== JSON.stringify(lastUsedShiftMetadata)
    ) {
      setColumnOptions(newColumnOptions);
      setLastUsedActiveStep(activeStep);
      setLastUsedSelections(workerSlotSelections);
      setLastUsedWorkersSelectedForAssignShift(workersSelectedForAssignShift);
      setLastUsedOpenFlexiSlots(openFlexiSlots);
      setLastUsedAvailableSlots(availableSlots);
      setLastUsedShiftMetadata(shiftMetadata);
    }
  }, [allColumns,
    columnOptions,
    activeStep,
    lastUsedActiveStep,
    lastUsedSelections,
    workerSlotSelections,
    workersSelectedForAssignShift,
    lastUsedWorkersSelectedForAssignShift,
    openFlexiSlots,
    lastUsedOpenFlexiSlots,
    availableSlots,
    lastUsedAvailableSlots,
    shiftMetadata,
    lastUsedShiftMetadata,
  ]);

  const visibleColumns = useMemo(() => {
    return columnOptions.filter((col) => col.checked);
  }, [columnOptions]);

  return [
		{
			shiftMetadata,
			jobRoleMetadata,
			workCenterMetadata,
			availableWorkersForShiftRow,
      columns: visibleColumns,
      columnOptions,
			allSkillLevels,
			confirmedWorkersCount,
			appliedWorkersCount,
			iAmSure,
			rowsV2,
			statusOptions,
			availablePreferredWorkersForShiftRow,
			status,
			removeWorkerDialogOpen,
			removeWorkerDetail,
			shiftId,
			remainingFilledPartialSlots,
      totalFullSpotsConfirmed,
      totalFlexiSpotsConfirmed,
      totalFlexiSpotsTotal,
      totalHalfSpotsConfirmed,
      openFlexiSlots,
      totalFirstHalfSpotsConfirmed,
      totalSecondHalfSpotsConfirmed,
      workersRequired,
      availableSlots,
		},
		{
			setAvailableWorkersForShiftRow,
			setAvailablePreferredWorkersForShiftRow,
			setRowsV2,
			setIAmSure,
			setStatusOptions,
			closeRemoveWorkerDialog,
			handleRemoveWorker,
      setColumnOptions,
    },
	];
};

export default useShiftDetailsDialogController;
